import React from 'react';
import { StopType } from '../../../redux/type';
import { types } from 'util';

interface Props {
  type: StopType | string;
  stopName: string;
  taskType: string;
}

const StopIcon = (props: Props) => {
  const { type, stopName, taskType } = props;
  if (!(type && stopName)) {
    return <></>;
  }
  const IconStopMap = new Map([
    ['START', 'icon_start'],
    ['LOAD', 'icon_start'],
    ['PICKUP', 'icon_pickup'],
    ['DROPOFF', 'icon_pickup'],
    ['UNLOAD', 'icon_unloading'],
    ['RETURN', 'icon_unloading'],
  ]);
  const StopPointMap = new Map([
    ['LOAD', '装载点'],
    ['PICKUP', '取货点'],
    ['DROPOFF', '取货点'],
    ['UNLOAD', '卸载点'],
    ['RETURN', '返程点'],
  ]);
  const iconType = IconStopMap.get(type);
  return (
    <div className='stop_icon_box'>
      <div className={`stop_icon ${iconType}`}>
        {type === 'START' ? '起点' : StopPointMap.get(type)}
      </div>
      <div className='stop_name'>{stopName}</div>
    </div>
  );
};
export default React.memo(StopIcon);
